import Observer from './vendor/observer.min'

export const OBSERVER = Observer.getInstance()